var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-compare" }, [
    _c(
      "div",
      { staticClass: "viq-compare__header" },
      [
        _c("h3", { staticClass: "viq-compare__title" }, [
          _vm._v("Compare Markets"),
        ]),
        _vm._v(" "),
        _vm.step === "form"
          ? _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.goBack } },
              [_vm._v("Back")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.step === "form"
      ? _c("div", { staticClass: "viq-compare__form" }, [
          _c("p", { staticClass: "viq-compare__desc" }, [
            _vm._v(
              "\n      Compare regulatory frameworks across multiple jurisdictions for strategic planning.\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "viq-compare__field" }, [
            _c("label", [_vm._v("Jurisdictions to Compare")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viq-compare__jurisdictions" },
              [
                _vm._l(_vm.jurisdictions, function (j, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "viq-compare__jurisdiction" },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "e.g., United Kingdom",
                        },
                        model: {
                          value: _vm.jurisdictions[i],
                          callback: function ($$v) {
                            _vm.$set(_vm.jurisdictions, i, $$v)
                          },
                          expression: "jurisdictions[i]",
                        },
                      }),
                      _vm._v(" "),
                      _vm.jurisdictions.length > 2
                        ? _c(
                            "button",
                            {
                              staticClass: "viq-compare__remove",
                              on: {
                                click: function ($event) {
                                  return _vm.removeJurisdiction(i)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 12 12",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M3 3l6 6M9 3l-6 6",
                                      stroke: "currentColor",
                                      "stroke-width": "1.2",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "viq-compare__add",
                    on: { click: _vm.addJurisdiction },
                  },
                  [_vm._v("\n          + Add jurisdiction\n        ")]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-compare__field" },
            [
              _c("label", [_vm._v("Focus Area")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  placeholder:
                    "e.g., Licensing requirements for payment institutions",
                },
                model: {
                  value: _vm.focusArea,
                  callback: function ($$v) {
                    _vm.focusArea = $$v
                  },
                  expression: "focusArea",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-compare__form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canSubmit },
                  on: { click: _vm.generate },
                },
                [_vm._v("\n        Compare Markets\n      ")]
              ),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "viq-compare__results" }, [
          _vm.isStreaming
            ? _c("div", { staticClass: "viq-compare__streaming" }, [
                _c("span", { staticClass: "viq-compare__spinner" }),
                _vm._v("\n      Comparing markets...\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.streamingText || _vm.reportContent
            ? _c("div", {
                staticClass: "viq-compare__content",
                domProps: { innerHTML: _vm._s(_vm.renderedContent) },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isStreaming
            ? _c(
                "div",
                { staticClass: "viq-compare__actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("export-pdf")
                        },
                      },
                    },
                    [_vm._v("Export as PDF")]
                  ),
                  _vm._v(" "),
                  _vm.$config.features && _vm.$config.features.viqShare
                    ? _c("el-button", { on: { click: _vm.share } }, [
                        _vm._v("Save & Share"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("New Comparison"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }